import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    title: string;
    details: string;
    downloadMac: string;
    downloadWindows: string;
    cancel: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Dialog title prompting the user to download the desktop app */
            title: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "AppDownloadDialogContent.title?c=3b4ktph3xb0v4", defaultMessage: "Download Frame Drive..." }));
                },
                enumerable: true,
                configurable: true
            },
            /** Dialog description explaining why the app is needed */
            details: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "AppDownloadDialogContent.details?c=1omhwgd3h6jcf", defaultMessage: "Mount projects on your desktop with Frame.io Drive" }));
                },
                enumerable: true,
                configurable: true
            },
            /** CTA to download the desktop app for macOS */
            downloadMac: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "AppDownloadDialogContent.downloadMac?c=33wyg24yo58zh", defaultMessage: "Get macOS app" }));
                },
                enumerable: true,
                configurable: true
            },
            /** CTA to download the desktop app for Windows */
            downloadWindows: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "AppDownloadDialogContent.downloadWindows?c=7vickj5ek719", defaultMessage: "Get Windows app" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Cancel / dismiss button */
            cancel: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "AppDownloadDialogContent.cancel?c=1h3mba94p9xl7", defaultMessage: "Close" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
